import {
  createCommand,
} from 'lexical';

export const SPELLCHECK_COMMAND = createCommand('SPELLCHECK_COMMAND');
export const AUTO_CORRECT_COMMAND = createCommand('AUTO_CORRECT_COMMAND');
export const PUNCTUATION_CORRECT_COMMAND = createCommand('PUNCTUATION_CORRECT_COMMAND');
